import { PARTNER_ID_MAPPING } from 'app/utils/constants'
import type { OfferDataResponseApiType } from 'app/api/api.schemas'

/**
 * Get the correct text to display based on the partner ID.
 * If the partner ID is in the production or staging KIZZO partner ID list, return the Kizzo text.
 * Otherwise, return the Fig text.
 * @param {string} partnerId - The partner ID
 * @returns {string} The correct text to display
 */
export const getKizzoOrFigTextByPartnerId = (partnerId: string): string => {
    return isPartnerKizzo(partnerId) ? 'partner.kizzo' : 'partner.fig'
}

/**
 * Check if the partner ID is a Kizzo partner ID.
 * @param {string} partnerId - The partner ID
 * @returns {boolean} True if the partner ID is a Kizzo partner ID, False otherwise
 */
export const isPartnerKizzo = (partnerId: string): boolean => {
    return partnerId === PARTNER_ID_MAPPING.production.KIZZO || partnerId === PARTNER_ID_MAPPING.staging.KIZZO
}

/**
 * Check if the offer is a Kizzo offer.
 * @param {PersonalLoanOffer} offer - The offer
 * @returns {boolean} True if the offer is a Kizzo offer, False otherwise
 */
export const isOfferKizzo = (offerData?: OfferDataResponseApiType): boolean => {
    return offerData?.is_kizzo ?? false
}

export default {
    getKizzoOrFigTextByPartnerId,
    isPartnerKizzo
}
